// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__10fFC","errorLogs":"styles_errorLogs__SNHn8"};